import { FileRecordNew } from '../../../types/file-record';
import { calcRelativeTime } from '../../../utilities/formatting';
import FileName from '../../files/FileName';
import RecordTypeIcon from '../../files/RecordTypeIcon';

type FilePreviewProps = {
    record: FileRecordNew;
};

function FilePreview({ record }: FilePreviewProps): JSX.Element {
    return (
        <div className="grid grid-cols-[subgrid] col-span-full py-2 px-1 border-b">
            <div className="flex items-center col-span-2 gap-2">
                <RecordTypeIcon recordType={record.recordType} />
                <FileName record={record} />
            </div>
            <p className="text-sm text-gray-600">{calcRelativeTime(record.updatedAt)}</p>
        </div>
    );
}

export default FilePreview;
